import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient,  HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ModalModule } from 'ngx-bootstrap';
import { TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { ProductCategoryRoutingModule } from './product-category-routing.module';

import { ProductCategoryCreateComponent, ProductCategoryCreateService } from './create';
import { ProductCategoryDetailComponent, ProductCategoryDetailService, ProductCategoryUpdateStatusService } from './detail';
import { ProductCategoryEditComponent, ProductCategoryEditService } from './edit';
import { ProductCategorySummaryComponent, ProductCategorySummaryService } from './summary';

import { SharedModule } from '../../shared';
import { CustomInterceptor } from './../../../helper';

import { DisplayIdModule } from '../../../directives';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  imports: [
    CommonModule,
    
    ProductCategoryRoutingModule,
    DisplayIdModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    SharedModule
  ],
  declarations: [
    ProductCategoryCreateComponent,
    ProductCategoryDetailComponent,
    // ProductCategoryDialogComponent,
    ProductCategoryEditComponent,
    ProductCategorySummaryComponent,
  ],
  providers: [
    ProductCategoryCreateService,
    ProductCategoryDetailService,
    ProductCategoryEditService,
    ProductCategorySummaryService,
    ProductCategoryUpdateStatusService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor, multi: true }
  ]
})
export class ProductCategoryModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/product-category.module.ts